import { useEffect, useState } from 'react';
import { useShopingCart } from '../../../ShoppingCart/hooks/useShopingCart';

import removeItems from '../../../ShoppingCart/assets/removeItems.svg';
import plus from '../../../ShoppingCart/assets/addItems.svg';

import './ButtonsActionsCart.css';

export const ButtonsActionsCart = ({ articulo, precios, moneda }) => {
  const { setItem, dataClient, getItems, handleChangeProduct } =
    useShopingCart();

  const [cantidad, setCantidad] = useState('0');

  useEffect(() => {
    const item = getItems().find((p) => p.id === articulo.id);
    const count = dataClient?.denominacion !== '' && item ? item.cantidad : 0;
    setCantidad(count.toString());
  }, [articulo?.id, dataClient?.denominacion, getItems]);

  const eliminarItemDelCarrito = () => {
    const nuevaCantidad = parseInt(cantidad || '0', 10) - 1;
    if (nuevaCantidad >= 0) {
      setCantidad(nuevaCantidad.toString());
      setItem({ ...articulo, cantidad: nuevaCantidad, precios });
    }
  };

  const agregarAlCarrito = () => {
    const precioctrl = precios?.monto_neto ?? 0;
    const actual = parseInt(cantidad || '0', 10);
    const nuevaCantidad = actual + 1;
    if (precioctrl > 0 && nuevaCantidad <= 9999) {
      setCantidad(nuevaCantidad.toString());
      setItem({ ...articulo, cantidad: nuevaCantidad, precios });
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;

    if (value === '' || /^[0-9]{1,4}$/.test(value)) {
      const numValue = value === '' ? 0 : parseInt(value, 10);

      setCantidad(value === '' ? '' : numValue.toString());

      if (!isNaN(numValue) && numValue <= 9999) {
        handleChangeProduct(articulo)({ target: { value: numValue } });
        setItem({ ...articulo, cantidad: numValue, precios });
      }
    }
  };

  const handleBlur = () => {
    if (cantidad === '' || cantidad === '0') {
      setCantidad('0');
      handleChangeProduct(articulo)({ target: { value: 0 } });
      setItem({ ...articulo, cantidad: 0, precios });
    }
  };

  return (
    <div className="fg-8 tabla__contenido buttons-actions-cart">
      <button
        type="button"
        id={articulo.id}
        value={articulo.id}
        className="selectorItemsCatalog"
        onClick={eliminarItemDelCarrito}
      >
        <img src={removeItems} alt="Quita Items" />
      </button>

      <input
        className="selectorItems"
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        value={cantidad}
        onChange={handleInputChange}
        onBlur={handleBlur}
        onKeyDown={(e) => {
          if (
            !/[0-9]/.test(e.key) &&
            !['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)
          ) {
            e.preventDefault();
          }
        }}
      />

      <button
        type="button"
        id={articulo.id}
        value={articulo.id}
        className="selectorItemsCatalog"
        onClick={agregarAlCarrito}
      >
        <img src={plus} alt="Agrega Items" />
      </button>
    </div>
  );
};
